import { AutogenLayoutEquipmentTypeQuickInfo } from "./autogen/AutogenLayoutEquipmentTypeQuickInfo";

export class EquipmentTypeQuickInfo extends AutogenLayoutEquipmentTypeQuickInfo {
}
